import { Crosshair } from "lucide-react";

const ITEMS = [
  "10 mm GNSS accuracy",
  "100 Hz IMU",
  "IP69K sensors",
  "Dual GNSS antennas",
  "DWG · DXF · LandXML",
  "iSite cloud OTA",
  "Engcon / Steelwrist ready",
  "2.5D & 3D guidance",
];

export default function Marquee() {
  return (
    <div data-testid="marquee-band" className="overflow-hidden border-y border-line bg-deep py-5">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {ITEMS.map((item) => (
              <span
                key={item}
                className="flex items-center gap-8 pr-8 font-mono text-xs uppercase tracking-[0.3em] text-fog"
              >
                {item}
                <Crosshair className="h-4 w-4 shrink-0 text-signal" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
